var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSocialIconRss281Bf24D7C4410186C85256Ba80286Cb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.536,
    height: 29.536,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 16645",
    d: "M14.768 0a14.768 14.768 0 1014.771 14.768A14.768 14.768 0 0014.768 0zm-3.875 21.288a1.883 1.883 0 01-2.661 0 1.876 1.876 0 011.33-3.2 1.873 1.873 0 011.332 3.2zm3.422.568v-.005a6.646 6.646 0 00-6.633-6.645V12.5a9.373 9.373 0 019.353 9.357zm4.827 0A11.486 11.486 0 007.685 10.384v-2.7a14.2 14.2 0 0114.171 14.177z",
    fill: "#f78422"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialIconRss281Bf24D7C4410186C85256Ba80286Cb);
export default __webpack_public_path__ + "static/media/social-icon-rss.281bf24d7c4410186c85256ba80286cb.ea873105cd54dbc67c2f7dfe8de904b8.svg";
export { ForwardRef as ReactComponent };